<template>
    <div class="h-100 d-flex flex-column">
        <div class="row mt-2">
            <div class="offset-4 col-8">
              <button type="button" class="btn btn-success btn-sm" @click="retry()">
                <i class="fas fa-redo"></i>
                Réessayer
              </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import LysiasApiMixin from '../mixins/LysiasApiMixin'
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Login from './Login.vue'
import CredentialsStore from '../store/credentials-store'
import nestedAppAuthenticationManager from '@/nested-app-authentication-manager'

@Component({ store: CredentialsStore, components: { Login } })
export default class OfficeAuthenticationFailed extends mixins(LysiasApiMixin)
{
  async retry()
  {
    try
    {
      await nestedAppAuthenticationManager.getToken(this.$store, this.$router);
      this.$router.push({ name: 'search'});
    }
    catch(e)
    {
      console.error(e);
    }
  }
}
</script>
